/* WL: "Added to your basket" window (snippets/wl-added.liquid).
 * Opens after every successful add to basket made on the page (product form, collection quick-add, upsell blocks):
 * it watches fetch() for POST /cart/add, so it needs no changes to the theme's own add-to-basket code.
 * Suggestions: the upsells app's picks for the product just added (/products/<handle>?view=wl-added, metafields
 * wl_upsells.pdp then wl_upsells.cart), topped up with Shopify's complementary then related products, never the product itself or anything already in the
 * basket, at most 12. Tamiya RC cars lead with their bearing set, a radio and a Tamiya bag. Not on the paint picker (#wlpp), which has its own once-at-checkout "Finish the job", and not for
 * adds made from the upsells app's blocks or the slide-out basket (already chosen from suggestions). */
(function () {
  'use strict';
  const dlg = document.getElementById('wla');
  if (!dlg || document.getElementById('wlpp') || !window.fetch) return;
  const ROUTE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const origFetch = window.fetch.bind(window); // the window's own adds use this, so they never reopen it
  const $ = id => document.getElementById(id);
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = p => '£' + (Number(p) / 100).toFixed(2);
  // Images in exactly the form the theme's own product grids request (shop-domain /cdn/shop/ path, width=400), so
  // they come straight from Shopify's image cache. An unusual size (or the cdn.shopify.com form) makes Shopify
  // resize the image on the spot: 0.5-1.4s each when measured, against a cache hit's few milliseconds.
  const IMG_W = 400;
  const sized = src => {
    if (!src) return '';
    let u = src.startsWith('//') ? 'https:' + src : src;
    u = u.replace(/^https:\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\/(files|products)\//, location.origin + '/cdn/shop/$1/');
    u = u.replace(/([?&])width=\d+&?/g, '$1').replace(/[?&]$/, '');
    return u + (u.includes('?') ? '&' : '?') + 'width=' + IMG_W;
  };
  const MAX = 12;

  /* ---------- Hook: every successful add to basket made with fetch ---------- */
  // The window opens the moment the request goes out (with "Adding…"), not when Shopify answers ~0.6s later, and closes
  // again if the add fails (the theme shows its own error then).
  window.fetch = function (input, init) {
    const res = origFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url.split('#')[0])) {
        // Added from a list of suggestions already (the upsell block on the page, the slide-out basket): no window.
        if (fromUpsell && Date.now() - fromUpsell < 5000) { fromUpsell = 0; return res; }
        let run;
        if (submitted && Date.now() - submitted.t < 4000 && current === submitted.run) { run = submitted.run; submitted = null; }
        else {
          const hint = pressed && Date.now() - pressed.t < 4000 ? pressed : null;
          pressed = null;
          run = opening(hint);
        }
        run.requested = true;
        res.then(r => r.ok ? r.clone().json().then(d => added(run, d), () => failed(run)) : failed(run), () => failed(run));
      }
    } catch (e) {}
    return res;
  };

  /* ---------- The window ---------- */
  let current = null, cart = null, runs = 0, pressed = null, byPointer = false, submitted = null;
  // Older cached markup has no title span; never let that stop the window opening.
  const setTitle = t => { const el = $('wla-title-text'); if (el) el.textContent = t; };
  const GHOSTS = Array.from({ length: 4 }, () => '<div class="wla-card wla-card--ghost" aria-hidden="true"><div class="wla-card-img"></div><div class="wla-card-vendor"></div><div class="wla-card-title"></div><div class="wla-card-price"></div><div class="wla-card-add"></div></div>').join('');
  function opening(hint) {
    const run = { id: ++runs, hint, shown: null };
    current = run;
    dlg.classList.add('is-adding');
    setTitle('Adding to your basket…');
    byPointer = !!hint || Date.now() - lastPointer < 4000;
    ['wla-img', 'wla-name', 'wla-variant', 'wla-price', 'wla-subtotal'].forEach(id => { $(id).innerHTML = ''; });
    $('wla-more').hidden = false;
    $('wla-track').innerHTML = GHOSTS;
    $('wla-track').scrollLeft = 0;
    if (!dlg.open) dlg.showModal();
    arrows();
    // The basket as it was (to leave out what is already in it), read alongside the add.
    run.before = readCart();
    // Pressed on a known product: its name, photo and price are usually loaded already, so the line shows at once
    // (Shopify takes ~0.8s to confirm; only the basket total waits for that), and so do its suggestions.
    if (hint) {
      const fill = () => { const m = meta.get(hint.handle); if (m && current === run && !run.confirmed) showLine({ title: m.t, img: m.img, price: m.price }); };
      if (meta.has(hint.handle)) fill(); else loadPicks(hint.handle, hint.productId).then(fill);
      show(run, hint.handle, hint.productId);
    }
    return run;
  }
  function showLine(x) {
    dlg.classList.remove('is-adding');
    setTitle('Added to your basket');
    $('wla-img').innerHTML = x.img ? `<img src="${esc(sized(x.img))}" alt="" width="96" height="96">` : '';
    $('wla-name').textContent = x.title || '';
    $('wla-variant').textContent = x.variant || '';
    $('wla-price').textContent = x.price != null ? money(x.price) + (x.qty > 1 ? ` · ${x.qty} in basket` : '') : '';
  }
  function added(run, data) {
    if (current !== run) return;
    const item = data && (Array.isArray(data.items) ? data.items[0] : data);
    if (!item || !item.product_id || (data.status && Number(data.status) >= 400)) return failed(run);
    run.confirmed = true;
    // Shopify's answer: the exact variant, price and quantity (the whole line's), replacing what was shown early.
    showLine({
      title: item.product_title || item.title || '',
      img: item.featured_image && item.featured_image.url || item.image,
      variant: item.variant_title && !/default title/i.test(item.variant_title) ? item.variant_title : '',
      price: item.final_price != null ? item.final_price : item.price,
      qty: item.quantity
    });
    readCart().then(c => { if (current === run) { cart = c; showSubtotal(); } });
    if (run.shown !== item.handle) show(run, item.handle, item.product_id);
  }
  function failed(run) { if (current === run) close(); }
  async function show(run, handle, productId) {
    run.shown = handle;
    const before = await run.before;
    const list = await buildList(handle, productId, before);
    if (current !== run || run.shown !== handle) return; // a newer add, or the real product turned out different
    dlg.dataset.anchor = handle;
    renderPicks(list, run);
  }
  // What goes with a product, never anything in `basket`: Tamiya RC priority items, then the upsells app's picks and
  // Shopify's complementary/related products, with two of Jadlam's own peppered in. Shared by the window and the drawer.
  // mode 'basket' (the slide-out basket and the basket page) puts the app's basket list (wl_upsells.cart) first.
  async function buildList(handle, productId, basket, mode) {
    const [picks, ownPool] = await Promise.all([loadPicks(handle, productId), loadOwn()]);
    const inBasket = new Set(((basket && basket.items) || []).map(l => l.handle));
    const seen = new Set();
    const keep = p => p.h !== handle && !inBasket.has(p.h) && !seen.has(p.h) && seen.add(p.h);
    const m = meta.get(handle);
    // Tamiya RC cars: the matching bearing set, a radio (unless one is included) and a Tamiya bag lead the list.
    const first = tamiyaRc(m) ? rcFirst(m, ownPool, await loadRadios()) : [];
    // The same Tamiya kit in another listing (its radio-bundle versions share the 5-digit item number) is not a suggestion.
    const kitNo = tamiyaRc(m) && (m.t.match(/\b(\d{5})\b/) || [])[1];
    const notSameKit = p => !kitNo || !new RegExp('\\b' + kitNo + '\\b').test(p.t);
    // The app's picks with its specific matches first (bucket nice/paint), then its essentials and add-ons, which are
    // mostly the same few workshop staples on every kit (cement, side cutters, decal setter); Shopify's own after.
    const RANK = { nice: 0, paint: 0, essential: 1, addon: 2 };
    const byBucket = arr => arr.map((p, i) => [p, i]).sort((x, y) => ((RANK[x[0].b] ?? 1) - (RANK[y[0].b] ?? 1)) || x[1] - y[1]).map(x => x[0]);
    const appCart = mode === 'basket' && m && m.cart ? m.cart : [];
    const fromApp = byBucket(appCart.concat(picks.filter(p => p.b !== undefined)));
    const shopify = picks.filter(p => p.b === undefined);
    const list = first.filter(keep).concat(fromApp.filter(p => notSameKit(p) && keep(p)), shopify.filter(p => notSameKit(p) && keep(p)));
    // Two of Jadlam's own products: third and seventh, or straight after the Tamiya RC priority items.
    const own = chooseOwn(m, ownPool, first.length ? /bearing|bag/i : null).filter(keep);
    (first.length ? [first.length + 2, first.length + 6] : [2, 6]).forEach((at, i) => { if (own[i]) list.splice(Math.min(at, list.length), 0, own[i]); });
    return list.slice(0, MAX);
  }
  function close() { if (dlg.open) dlg.close(); }

  async function readCart() {
    try { const r = await origFetch(ROUTE + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }); return r.ok ? await r.json() : null; } catch (e) { return null; }
  }
  function showSubtotal() {
    if (!cart) return;
    $('wla-subtotal').innerHTML = `Basket: <b>${money(cart.total_price)}</b> · ${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
  }

  /* ---------- Suggestions ---------- */
  // Fetched as early as possible and kept for the visit: on a product page as soon as the page is idle, elsewhere the
  // moment an add-to-basket button is pressed down. The three sources load side by side, not one after another.
  const cache = new Map(); // handle -> promise of picks
  const meta = new Map();  // handle -> { t, type, vendor, tags } of the product itself
  const recs = (id, intent) => origFetch(`${ROUTE}recommendations/products.json?product_id=${id}&limit=12&intent=${intent}`)
    .then(r => r.ok ? r.json() : null).then(j => ((j && j.products) || []).map(p => {
      const v = (p.variants || []).find(x => x.available);
      if (!v) return null;
      const was = v.compare_at_price && v.compare_at_price - v.price >= Math.max(50, v.price * .03) ? v.compare_at_price : 0;
      return { h: p.handle, t: p.title, vendor: p.vendor, url: p.url || `${ROUTE}products/${p.handle}`, v: v.id, price: v.price, was, img: p.featured_image };
    }).filter(Boolean)).catch(() => []);
  function loadPicks(handle, productId) {
    if (!handle) return Promise.resolve([]);
    if (!cache.has(handle)) {
      // No Accept: application/json here: with it Shopify answers with its own product JSON, not this view.
      const app = origFetch(`${ROUTE}products/${encodeURIComponent(handle)}?view=wl-added`).then(r => r.ok ? r.json() : null)
        .then(j => { if (j) { meta.set(handle, { t: j.t || '', type: j.type || '', vendor: j.vendor || '', tags: (j.tags || []).join(' '), price: j.price, img: j.img, cart: j.cart || [] }); if (tamiyaRc(meta.get(handle))) loadRadios(); } return j ? (j.picks || []).concat(j.cart || []) : []; }).catch(() => []);
      const more = productId ? Promise.all([recs(productId, 'complementary'), recs(productId, 'related')]) : Promise.resolve([[], []]);
      const all = Promise.all([app, more]).then(([a, [b, c]]) => a.concat(b, c));
      all.then(p => { if (!p.length) cache.delete(handle); });
      cache.set(handle, all);
    }
    return cache.get(handle);
  }

  /* ---------- Jadlam's own products, peppered in ---------- */
  // Vendor "Jadlam" (3D-printed holders, palettes, caddies, the airbrush cleaning kit; RC bearings and wall mounts).
  // Modelling products get the workbench ones, RC products the RC ones, everything else (LEGO, toys, diecast...) none.
  // The most relevant first (a Citadel paint holder after Citadel paint, a Tamiya cement holder after Tamiya cement),
  // otherwise a rotating pick so it is not always the same two.
  let ownPromise = null;
  const loadOwn = () => ownPromise || (ownPromise = origFetch(`${ROUTE}collections/vendors?q=Jadlam&view=wlpp-supplies`)
    .then(r => r.ok ? r.json() : null)
    .then(j => ((j && j.products) || []).filter(p => p.avail).map(p => ({ h: p.h, t: p.t, vendor: p.vendor, url: `${ROUTE}products/${p.h}`, v: p.v, price: p.price, was: 0, img: p.img, own: true })))
    .catch(() => { ownPromise = null; return []; }));
  const NOT_MODELLING = /\blego\b|\btoys?\b|diecast|die-cast|jigsaw|puzzle|board game|plush|gift card/i;
  const RC = /radio control|\brc\b|r\/c/i;
  const MODELLING = /model kit|model accessor|plastic kit|paint|primer|thinner|varnish|cement|glue|airbrush|weathering|decal|brush|tool|modelling|warhammer|wargam|citadel|figure/i;
  const OWN_RC = /bearing|rc car|wall mount|pit mat/i;
  const OWN_SKIP = /gift card|glider|foam/i;
  const RELEVANCE = [
    [/citadel|warhammer|games workshop/i, /citadel/i], [/tamiya/i, /tamiya/i], [/mr\.? ?hobby|mr\.? ?(colou?r|cement)/i, /mr hobby/i],
    [/microscale|micro ?(set|sol)|decal/i, /microscale|micro ?set|micro ?sol/i], [/revell|enamel|email/i, /revell|tinlet/i],
    [/airbrush/i, /airbrush/i], [/marker/i, /marker/i], [/cement|glue/i, /cement|glue/i], [/wash|panel line/i, /wash|panel/i],
    [/nipper|cutter|sprue/i, /nipper|cutter|caddy/i], [/thinner/i, /thinner/i], [/paint/i, /paint|palette|dropper/i],
    [/model kit|plastic kit/i, /cement|nipper|caddy|tool/i]
  ];
  function chooseOwn(m, pool, without) {
    if (!m || !pool || !pool.length) return [];
    const about = `${m.type} ${m.tags} ${m.t} ${m.vendor}`;
    const rc = RC.test(about) && !/plastic kit|model kit/i.test(m.type);
    if (!rc && (NOT_MODELLING.test(`${m.type} ${m.tags}`) || !MODELLING.test(about))) return [];
    const cands = pool.filter(p => !OWN_SKIP.test(p.t) && !(without && without.test(p.t)) && (rc ? OWN_RC.test(p.t) : !OWN_RC.test(p.t)));
    const score = p => RELEVANCE.reduce((n, [when, then]) => n + (when.test(about) && then.test(p.t) ? 1 : 0), 0) + Math.random() * .5;
    // Never two colours of the same thing (the red and the grey holder): one of each.
    const base = t => t.replace(/\((red|grey|gray|blue|black|white|green)\)/ig, '').replace(/\s+/g, ' ').trim();
    const out = [];
    for (const [, p] of cands.map(p => [score(p), p]).sort((a, b) => b[0] - a[0])) {
      if (!out.some(q => base(q.t) === base(p.t))) out.push(p);
      if (out.length === 2) break;
    }
    return out;
  }

  /* ---------- Tamiya RC cars: bearings, radio, bag first ---------- */
  // Tamiya's cars and trucks are product type "RC Vehicles" (parts are "RC Other"). Jadlam's bearing sets are named for
  // the chassis or model they fit ("Tamiya TT-02/TT-02D Ballrace Bearings..."), so the car's title and tags pick the
  // set; no match, no bearings (never a wrong set). Radio: the best-selling in-stock "Ideal for Tamiya" bundle (the
  // truck bundle for trucks), skipped when the kit already includes a radio. Bag: the Tamiya 1/10 holdall, 1/10 cars only.
  const tamiyaRc = m => !!m && /^tamiya$/i.test(m.vendor) && /rc vehicles/i.test(m.type);
  let radioPromise = null;
  const loadRadios = () => radioPromise || (radioPromise = origFetch(`${ROUTE}collections/rc-radio-packages?view=wlpp-supplies&sort_by=best-selling`)
    .then(r => r.ok ? r.json() : null)
    .then(j => ((j && j.products) || []).filter(p => p.avail).map(p => ({ h: p.h, t: p.t, vendor: p.vendor, url: `${ROUTE}products/${p.h}`, v: p.v, price: p.price, was: 0, img: p.img })))
    .catch(() => { radioPromise = null; return []; }));
  const norm = s => ' ' + String(s || '').toLowerCase().replace(/[-_]/g, '').replace(/[^a-z0-9]+/g, ' ') + ' ';
  // Well-known kits whose names do not say the chassis.
  const CHASSIS_ALIAS = [[/lunch ?box|midnight pumpkin|bull ?head/i, 'cw01'], [/mud blaster/i, 'wr02'], [/monster beetle|sand scorcher|rough rider/i, 'orv srb']];
  function bearingFor(m, pool) {
    let about = norm(`${m.t} ${m.tags}`), best = null, len = 0;
    for (const [re, key] of CHASSIS_ALIAS) if (re.test(m.t)) about += ' ' + key + ' ';
    for (const p of pool) {
      const name = (p.t.match(/Tamiya (.+?) Ballrace Bearings RC Car Upgrade Set/i) || [])[1];
      if (!name) continue;
      for (const k of name.split('/').map(x => norm(x).trim()).filter(x => x && x !== '4wd')) {
        if (about.includes(' ' + k + ' ') && k.length > len) { best = p; len = k.length; }
      }
    }
    return best;
  }
  function rcFirst(m, ownPool, radios) {
    const out = [];
    // Road trucks (1:14/1:16 tractors and tippers), not monster trucks.
    const truck = /\b1:1[46]\b|tractor|hauler|scania|arocs|actros|volvo|tipper|racing truck/i.test(m.t);
    // Radios and the 1/10 holdall suit 1:10 and 1:12 cars (or kits that do not say).
    const scaleOk = !/1:(?!1[02]\b)\d+/.test(m.t);
    const bearing = !truck && bearingFor(m, ownPool || []);
    if (bearing) out.push(bearing);
    if ((truck || scaleOk) && !/radio bundle|\+ ?radio|w\/ ?radio|rc car bundle|all in one|\brtr\b|ready to run/i.test(m.t)) {
      const radio = (radios || []).find(p => truck ? /truck/i.test(p.t) : /ideal for tamiya|perfect for tamiya/i.test(p.t));
      if (radio) out.push(radio);
    }
    if (!truck && scaleOk) {
      const bag = (ownPool || []).find(p => /tamiya rc car carry bag holdall 1\/10/i.test(p.t));
      if (bag) out.push(bag);
    }
    return out;
  }

  // Warm-up: the product on a product page, at idle.
  const pdp = location.pathname.match(/\/products\/([^/?#\s]+)/);
  const metaId = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id;
  // The first few suggestions' images are fetched too, so the window's first view is ready to show.
  const preload = picks => picks.slice(0, 5).forEach(p => { if (p.img) new Image().src = sized(p.img); });
  if (pdp) (window.requestIdleCallback || (f => setTimeout(f, 1200)))(() => { loadOwn(); loadPicks(decodeURIComponent(pdp[1]), metaId).then(preload); });
  // ...and any add-to-basket form, when its button is pressed (a quick-add on a collection, say).
  let lastPointer = 0, fromUpsell = 0;
  // Clicks (mouse, touch or keyboard) inside the upsells app's blocks or the slide-out basket mark the add that follows.
  const UPSELL_AREAS = '[data-wl-upsell], .wlu, cart-drawer, #CartDrawer, .wbcartupsell';
  document.addEventListener('click', e => { fromUpsell = e.target.closest && e.target.closest(UPSELL_AREAS) ? Date.now() : 0; }, true);
  // Which product a basket form adds: the page's own product on a product page (its form carries the page product's
  // id), otherwise the product card the form sits in. Only a sure match counts: a wrong guess would show another
  // product's suggestions. (Card links can end in a stray newline, hence the trim.)
  function handleOf(form) {
    const id = form.querySelector('[name="product-id"]');
    if (pdp && id && metaId && String(id.value) === String(metaId)) return decodeURIComponent(pdp[1]);
    const card = form.closest('.card-wrapper, .product-card-wrapper, .card, .grid__item');
    const links = card ? [...new Set([...card.querySelectorAll('a[href*="/products/"]')].map(a => (a.getAttribute('href').trim().match(/\/products\/([^/?#\s]+)/) || [])[1]).filter(Boolean))] : [];
    return links.length === 1 ? links[0] : null;
  }
  document.addEventListener('pointerdown', e => {
    lastPointer = Date.now();
    const form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    const handle = handleOf(form);
    if (!handle) return;
    const id = form.querySelector('[name="product-id"]');
    pressed = { handle, productId: id ? id.value : null, t: Date.now() };
    loadOwn();
    loadPicks(handle, pressed.productId).then(preload);
  }, { passive: true, capture: true });
  // The theme's basket forms check a quantity limit (a whole /cart.js round trip) before they add, so the window opens
  // on the form's submit rather than waiting for the add request. If no add follows (the limit was reached and the
  // theme shows its own message), the window gets out of the way.
  document.addEventListener('submit', e => {
    const form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]') || dlg.contains(form) || form.closest(UPSELL_AREAS)) return;
    const handle = handleOf(form);
    if (!handle) return;
    const id = form.querySelector('[name="product-id"]');
    pressed = null;
    const run = opening({ handle, productId: id ? id.value : null, t: Date.now() });
    submitted = { run, t: Date.now() };
    run.noAdd = setTimeout(() => { if (current === run && !run.requested) close(); }, 4000);
    if (typeof window.openModal === 'function' && !window.openModal.wlaWrapped) {
      const theirs = window.openModal;
      window.openModal = function () { close(); return theirs.apply(this, arguments); };
      window.openModal.wlaWrapped = true;
    }
  }, true);
  const cardHtml = (p, i) => `<article class="wla-card${p.own ? ' wla-card--own' : ''}"><a class="wla-card-img" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${p.img ? `<img src="${esc(sized(p.img))}" alt=""${i < 4 ? ' fetchpriority="high"' : ' loading="lazy"'} width="180" height="180">` : ''}</a><div class="wla-card-vendor">${p.own ? '<i>Jadlam’s own</i>' : esc(p.vendor)}</div><a class="wla-card-title" href="${esc(p.url)}" title="${esc(p.t)}">${esc(p.t)}</a><div class="wla-card-price">${money(p.price)}${p.was ? `<s>${money(p.was)}</s>` : ''}</div><button type="button" class="wla-card-add" data-wla-add="${p.v}" data-wla-bucket="${p.own ? 'jadlam_own' : 'suggested'}" aria-label="Add ${esc(p.t)} to basket">Add to basket</button></article>`;
  // The first four go in straight away; the rest follow once those four images have arrived (or after 1.5s at most),
  // so the first view is never waiting behind images nobody can see yet.
  let renderToken = 0;
  function renderPicks(picks, run) {
    const track = $('wla-track'), token = ++renderToken;
    if (!picks.length) { $('wla-more').hidden = true; return; }
    track.innerHTML = picks.slice(0, 4).map(cardHtml).join('');
    track.scrollLeft = 0;
    arrows();
    listed(dlg);
    if (picks.length <= 4) return;
    const imgs = [...track.querySelectorAll('img')];
    Promise.race([
      Promise.all(imgs.map(i => i.complete ? 0 : new Promise(r => { i.onload = i.onerror = r; }))),
      new Promise(r => setTimeout(r, 1500))
    ]).then(() => {
      if (current !== run || token !== renderToken) return; // replaced since: never append to someone else's list
      track.insertAdjacentHTML('beforeend', picks.slice(4).map((p, i) => cardHtml(p, i + 4)).join(''));
      arrows();
      listed(dlg);
    });
  }

  /* ---------- Shown / added, for the upsells app's "Recorded activity" ---------- */
  // Same endpoint and format as the app's product page block (/apps/wl-upsells/track, its session id, the main product
  // as anchor, the suggested variant as candidate), so these surfaces get impressions and an add rate beside the sales
  // their _wl_upsell tag already brings in. A list counts as shown once it has actually been on screen (the slide-out
  // basket is often filled while closed). Fire and forget: never in the way of an add.
  const SURFACE_OF = { wla: 'popup', 'wla-drawer': 'drawer', 'wla-basket': 'basket' };
  function sid() {
    try {
      let v = sessionStorage.getItem('wlu-sid');
      if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem('wlu-sid', v); }
      return v;
    } catch (e) { return 'anonymous'; }
  }
  function report(area, event, buttons) {
    const surface = area && SURFACE_OF[area.id], anchor = area && area.dataset.anchor;
    if (!surface || !anchor || !buttons.length) return;
    const all = [...area.querySelectorAll('[data-wla-add]')];
    const rows = buttons.map(b => ({ surface, event, anchorId: anchor, candidateId: b.dataset.wlaAdd, bucket: b.dataset.wlaBucket || 'unknown', position: all.indexOf(b) + 1 }));
    for (let i = 0; i < rows.length; i += 12) { // the endpoint takes 12 a call
      try { origFetch('/apps/wl-upsells/track', { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true, body: JSON.stringify({ sessionId: sid(), events: rows.slice(i, i + 12) }) }).catch(() => {}); } catch (e) {}
    }
  }
  // Each card counts once it is mostly in view: the window's row shows four at a time and the slide-out basket is
  // often filled while closed. Cards seen together go in one call per list.
  const reported = new WeakSet(), queue = new Map();
  let flushTimer = 0;
  function seen(btn) {
    if (reported.has(btn)) return;
    const area = btn.closest('#wla, #wla-drawer, #wla-basket');
    if (!area) return;
    reported.add(btn);
    if (!queue.has(area)) queue.set(area, []);
    queue.get(area).push(btn);
    clearTimeout(flushTimer);
    flushTimer = setTimeout(() => { queue.forEach((btns, a) => report(a, 'shown', btns)); queue.clear(); }, 250);
  }
  const seenIO = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { seen(e.target.querySelector('[data-wla-add]')); seenIO.unobserve(e.target); }
  }), { threshold: 0.6 }) : null;
  function listed(area) {
    if (!area) return;
    area.querySelectorAll('.wla-card').forEach(card => { const b = card.querySelector('[data-wla-add]'); if (b && !reported.has(b)) { if (seenIO) seenIO.observe(card); else seen(b); } });
  }

  /* ---------- Adding a suggestion (stays in the window) ---------- */
  // Every add is stamped on the basket line, hidden from shoppers (keys starting "_"): which surface sold it, the same
  // _wl_upsell key the upsells app's attribution reads (it reports each value as its own row), and the main product
  // it was suggested for (_wl_anchor), so sales can be read per main product.
  function tagFor(btn) {
    const area = btn.closest('#wla, #wla-drawer, #wla-basket');
    const surface = !area ? 'popup' : area.id === 'wla' ? 'popup' : area.id === 'wla-drawer' ? 'drawer' : 'basket';
    const tag = { _wl_upsell: surface };
    if (area && area.dataset.anchor) tag._wl_anchor = area.dataset.anchor;
    return tag;
  }
  async function addPick(btn) {
    btn.disabled = true; btn.textContent = 'Adding…';
    try {
      const r = await origFetch(ROUTE + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.wlaAdd), quantity: 1, properties: tagFor(btn) }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) });
      const data = await r.json().catch(() => null);
      if (!r.ok) throw new Error((data && typeof data.description === 'string' && data.description) || 'Sorry, that could not be added.');
      btn.classList.add('is-added'); btn.textContent = 'Added ✓';
      report(btn.closest('#wla, #wla-drawer, #wla-basket'), 'added', [btn]);
      themeCart(data && data.sections);
      cart = await readCart(); showSubtotal();
    } catch (e) {
      btn.disabled = false; btn.textContent = 'Add to basket'; btn.title = e.message;
    }
  }
  // Keep the header count and the slide-out basket in step, the same way the theme does after an add.
  function themeCart(sections) {
    const drawer = document.querySelector('cart-drawer');
    if (sections && drawer && typeof drawer.renderContents === 'function') { try { drawer.renderContents({ id: null, sections }); } catch (e) {} }
    else if (sections && sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const fresh = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble');
      if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
    }
    if (drawer) drawer.classList.remove('is-empty');
    try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wl-added' }); } catch (e) {}
  }

  /* ---------- Arrows: a view (four cards) at a time ---------- */
  const track = $('wla-track');
  function arrows() {
    const [prev, next] = dlg.querySelectorAll('[data-wla-step]');
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }
  track.addEventListener('scroll', () => requestAnimationFrame(arrows), { passive: true });

  /* ---------- Slide-out basket: suggestions when the upsells app has none ---------- */
  // The upsells app (#wl-drawer-upsell) shows basket suggestions only when the dearest item in the basket has picks of
  // its own. When it has nothing, the same suggestions as the window fill that spot, for the dearest item, leaving out
  // everything already in the basket. The app's own block always wins: ours steps aside whenever it is there.
  const DRAWER_FOOTER = '.cart-drawer__footer, .drawer__footer, [class*="drawer__footer"]';
  let drawerTimer = 0, drawerKey = '', drawerBusy = false;
  function scheduleDrawer() { clearTimeout(drawerTimer); drawerTimer = setTimeout(fillDrawer, 900); }
  async function fillDrawer() {
    const root = document.getElementById('CartDrawer');
    if (!root || drawerBusy) return;
    let box = document.getElementById('wla-drawer');
    const app = root.querySelector('#wl-drawer-upsell');
    if (app && app.children.length) { if (box) box.remove(); drawerKey = ''; return; }
    drawerBusy = true;
    try {
      const c = await readCart();
      if (!c || !c.items || !c.items.length) { if (box) box.remove(); drawerKey = ''; return; }
      const key = c.items.map(i => i.key + ':' + i.quantity).join(',');
      if (box && root.contains(box) && key === drawerKey) return;
      const top = c.items.slice().sort((x, y) => y.final_line_price - x.final_line_price)[0];
      const list = (await buildList(top.handle, top.product_id, c, 'basket')).slice(0, 8);
      if (root.querySelector('#wl-drawer-upsell')?.children.length) return; // the app arrived meanwhile
      box = document.getElementById('wla-drawer');
      if (!list.length) { if (box) box.remove(); drawerKey = key; return; }
      if (!box || !root.contains(box)) {
        if (box) box.remove();
        box = document.createElement('div');
        box.id = 'wla-drawer';
        box.className = 'wla-drawer';
        const footer = root.querySelector(DRAWER_FOOTER);
        if (footer && footer.parentNode) footer.parentNode.insertBefore(box, footer); else return;
      }
      drawerKey = key;
      box.dataset.anchor = top.handle;
      box.innerHTML = `<div class="wla-drawer-head">Goes well with your basket</div><div class="wla-drawer-row">${list.map(cardHtml).join('')}</div>`;
      listed(box);
    } finally { drawerBusy = false; }
  }
  // The theme rebuilds the drawer's contents after every basket change, which removes this block: put it back.
  const drawerEl = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
  if (drawerEl) {
    new MutationObserver(muts => {
      if (muts.every(mu => mu.target.closest && mu.target.closest('#wla-drawer'))) return;
      scheduleDrawer();
    }).observe(drawerEl, { childList: true, subtree: true });
    drawerEl.addEventListener('click', e => {
      const b = e.target.closest('#wla-drawer [data-wla-add]');
      if (b) { e.preventDefault(); e.stopPropagation(); addPick(b); }
    });
    scheduleDrawer();
  }

  /* ---------- Basket page: "Goes well with your basket" (sections/wl-basket-suggestions.liquid) ---------- */
  const basketSlot = document.getElementById('wla-basket');
  if (basketSlot) {
    let basketKey = '', basketTimer = 0;
    const fillBasket = async () => {
      const c = await readCart();
      if (!c || !c.items || !c.items.length) { basketSlot.hidden = true; basketKey = ''; return; }
      const key = c.items.map(i => i.key + ':' + i.quantity).join(',');
      if (key === basketKey) return;
      basketKey = key;
      const top = c.items.slice().sort((x, y) => y.final_line_price - x.final_line_price)[0];
      const list = await buildList(top.handle, top.product_id, c, 'basket');
      if (basketKey !== key) return;
      basketSlot.hidden = !list.length;
      basketSlot.dataset.anchor = top.handle;
      basketSlot.querySelector('.wla-basket-row').innerHTML = list.map(cardHtml).join('');
      listed(basketSlot);
    };
    const later = () => { clearTimeout(basketTimer); basketTimer = setTimeout(fillBasket, 400); };
    fillBasket();
    // The theme re-renders the basket items after every change: work the suggestions out again then.
    const items = document.querySelector('cart-items');
    if (items) new MutationObserver(later).observe(items, { childList: true, subtree: true });
    basketSlot.addEventListener('click', e => {
      const b = e.target.closest('[data-wla-add]');
      if (b) { e.preventDefault(); addPick(b).then(later); }
    });
  }

  /* ---------- Events ---------- */
  // Closing hands focus back to the Add To Basket button, which then wears the theme's focus ring. Fine for keyboard
  // users; for a mouse or finger it reads as a stuck outline, so focus is let go.
  dlg.addEventListener('close', () => setTimeout(() => {
    const a = document.activeElement;
    if (byPointer && a && a !== document.body && a.matches('button, [type="submit"], a')) a.blur();
  }, 0));
  dlg.addEventListener('click', e => {
    if (e.target === dlg) return close();
    const b = e.target.closest('button');
    if (!b) return;
    if (b.dataset.wlaAdd) addPick(b);
    else if (b.dataset.wlaStep) track.scrollBy({ left: Number(b.dataset.wlaStep) * track.clientWidth, behavior: 'smooth' });
    else if (b.hasAttribute('data-wla-close')) close();
    else if (b.hasAttribute('data-wla-basket')) {
      close();
      const d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') d.open(); else location.href = ROUTE + 'cart';
    }
  });
})();
